import { EMPLOYEE_SMART_FITNESS_BAND_ROUTER } from "@Router/routerPath";
import { SmartFitnessBandPage } from "@Local/Member";

const EmployeeProfileRouter = [
    {
        description: '教練智能系統',
        static: true,
        path: EMPLOYEE_SMART_FITNESS_BAND_ROUTER,
        href: EMPLOYEE_SMART_FITNESS_BAND_ROUTER,
        as: SmartFitnessBandPage,
    }
];

export default EmployeeProfileRouter;
